/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TransactionReasonBundle {
    PURCHASE = 'Purchase',
    REFERRAL = 'Referral',
    MANUAL = 'Manual',
    BOOST = 'Boost',
}
